// extracted by mini-css-extract-plugin
export default {"tabs":"PatientAndWaitingListNavigation_tabs__98gUY","tab":"PatientAndWaitingListNavigation_tab__qVb6l"};